export const superAdmin = 'Super Admin';
